import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const ExecutiveSummary = lazy(() => import('../components/ExecutiveSummary'));

const executiveSummaryRoute: RouteObject = {
  path: '/executive-summary',
  element: <ExecutiveSummary />,
};

export default executiveSummaryRoute;
